// StorePage1.tsx
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SubmitButton from "../../../components/form/SubmitButton";
import MainTitle from "../../../components/ui/MainTitle";
import StoreBasicInfoForm from "../../../components/store/createStoreForms/StoreBasicInfoForm";
import { useSectors } from "../../../hooks/store/sector";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../../components/form/LoadingButton";
import { useInCompleteStore } from "../../../hooks/store/store";
import LoadingErrorState from "../../../components/ui/LoadingErrorState";

export interface PageBasicFormFormData {
  name: { languageCode: string; brand:string}[];
  sectorId:number|null
}

export default function StoreBasicPage() {
   const { ownerId} = useParams<{ ownerId: string}>();
   const numericOwnerId = ownerId ? parseInt(ownerId) : 0;
 
   const navigate = useNavigate();
 

   const {data:store , isLoading, isError} = useInCompleteStore(numericOwnerId);

   
   const { control, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<PageBasicFormFormData>({
     defaultValues: {
       name: [{ languageCode: 'en',brand:"" }, { languageCode: 'ar',brand:"" }],
       sectorId:null,
     }
   });
 

   useEffect(()=>{
    if(store?.hasIncompleteStore && store.store){
      setValue("sectorId",store.store.sector.id)
      setValue("name",store.store.languages)
    }
   },[store,setValue])
 
 
   const {data:sectors} = useSectors();
 
   const { loading, updateResource } = useUpdateResource();
 

  const onNext = (data:PageBasicFormFormData) => {
    const endPoint = numericOwnerId ? `store/initial-create?ownerId=${numericOwnerId}` : `store/initial-create`
    updateResource(endPoint, {sectorId:data.sectorId,languages:data.name}, numericOwnerId?"admin": "owner",{
            method: "POST",
            navigateAfter: () => navigate(numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page1`: "/owner/add-store/page1"),
          });
  };

  return (
    <div className="p-6 container h-[100vh] overflow-auto">
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {
        store &&
        <form onSubmit={handleSubmit(onNext)} className="flex flex-col gap-4 w-full">
        <MainTitle title="Store Information" />
        <StoreBasicInfoForm register={register} errors={errors} 
        sectors={sectors||[]}
        control={control}
        selectedSectorId={watch("sectorId")}
        onSelectSector={(id)=>setValue("sectorId",id,{shouldValidate:true})}
        />
        {
            loading
            ?
            <LoadingButton height={64}/>
            :
            <SubmitButton height={64} label="next" />
        }
      </form>
      }
    </div>
  );
}
